import { render, staticRenderFns } from "./CPAccountSummaryOutOfDate.vue?vue&type=template&id=460d99e4&scoped=true&"
import script from "./CPAccountSummaryOutOfDate.vue?vue&type=script&lang=ts&"
export * from "./CPAccountSummaryOutOfDate.vue?vue&type=script&lang=ts&"
import style0 from "./CPAccountSummaryOutOfDate.vue?vue&type=style&index=0&id=460d99e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d99e4",
  null
  
)

export default component.exports